import { Button } from '@cian/ui-kit/button';
import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './CookiesNotification.css';

interface ICookiesNotificationProps {
  noResize?: boolean;
  onAgreementView(): void;
  onAccept(): void;
}

export const CookiesNotification: React.FC<ICookiesNotificationProps> = ({ noResize, onAgreementView, onAccept }) => {
  const handleAgreementView = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onAgreementView();
  };

  return (
    <div
      className={classNames(styles['container'], noResize && styles['desktop-only'], !noResize && styles['adaptive'])}
      data-testid="cookies-notification"
    >
      <div className={styles['description']}>
        Мы используем файлы cookie.{' '}
        <a href="#" className={styles['agreement']} onClick={handleAgreementView}>
          Соглашение об использовании
        </a>
      </div>
      <div className={styles['button']}>
        <Button onClick={onAccept} theme="fill_white_primary">
          Принять
        </Button>
      </div>
    </div>
  );
};
